module.exports = __webpack_public_path__ + "static/media/reloj_rojo.2f2b9849.svg";